module.exports = __webpack_public_path__ + "img/17-r.7f081c9b.png";